import React, {useMemo} from "react";
import {Box, styled} from "@mui/material";


type GridOverlayType = {
    label: string;
}
const StyledGridOverlay = styled("div")(({theme}) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    "& .no-results-primary": {
        fill: "#3D4751",
        ...theme.applyStyles("light", {
            fill: "#AEB8C2",
        }),
    },
    "& .no-results-secondary": {
        fill: "#1D2126",
        ...theme.applyStyles("light", {
            fill: "#E8EAED",
        }),
    },
}));

const DocOverlay = ({label}: GridOverlayType) => {
    return <>
        <svg width="66px" height="66px" viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" fill="#AEB8C2">

            <g id="SVGRepo_bgCarrier" strokeWidth="0"/>

            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"/>

            <g id="SVGRepo_iconCarrier">
                <title/>
                <g data-name="outline color" id="outline_color">
                    <path className="cls-1"
                          d="M22,60a1,1,0,0,1-.5-.13l-9-5a1,1,0,0,1,0-1.74l9-5a1,1,0,0,1,1.43.49A14.29,14.29,0,0,1,24,54a14.4,14.4,0,0,1-1.06,5.38A1,1,0,0,1,22,60Zm-7-6,6.4,3.56A12.17,12.17,0,0,0,22,54a12,12,0,0,0-.54-3.56Z"/>
                    <path className="cls-1"
                          d="M59,60H22a1,1,0,0,1-.83-.44,1,1,0,0,1-.1-.94A12.33,12.33,0,0,0,22,54a12.13,12.13,0,0,0-.92-4.62,1,1,0,0,1,.1-.94A1,1,0,0,1,22,48H59a1,1,0,0,1,1,1V59A1,1,0,0,1,59,60ZM23.42,58H58V50H23.42A13.87,13.87,0,0,1,24,54,14.27,14.27,0,0,1,23.42,58Z"/>
                    <path className="cls-1" d="M47,56H24a1,1,0,0,1,0-2H47a1,1,0,0,1,0,2Z"/>
                    <path className="cls-1" d="M52,59a1,1,0,0,1-1-1V50a1,1,0,0,1,2,0v8A1,1,0,0,1,52,59Z"/>
                    <path className="cls-2"
                          d="M16.27,48.61a1,1,0,0,1-.91-.59L4.56,23.83a5,5,0,0,1,2.52-6.6l20.17-9A1,1,0,0,1,28.07,10l-20.17,9a3,3,0,0,0-1.52,4L17.18,47.2a1,1,0,0,1-.5,1.32A1,1,0,0,1,16.27,48.61Z"/>
                    <path className="cls-3" d="M16.74,22.68a1,1,0,0,1-.92-.6,1,1,0,0,1,.51-1.32l8.22-3.67a1,1,0,1,1,.81,1.83l-8.22,3.67A1,1,0,0,1,16.74,22.68Z"/>
                    <path className="cls-3" d="M16.44,29.38A1,1,0,0,1,16,27.47l6.78-3a1,1,0,0,1,.82,1.82l-6.78,3A1,1,0,0,1,16.44,29.38Z"/>
                    <path className="cls-3" d="M18.89,34.85a1,1,0,0,1-.41-1.91l2.29-1a1,1,0,0,1,.82,1.82l-2.29,1A1,1,0,0,1,18.89,34.85Z"/>
                    <path className="cls-2"
                          d="M51,46a.75.75,0,0,1-.26,0,1,1,0,0,1-.7-1.22L57.9,16.11a3,3,0,0,0-.3-2.28,2.9,2.9,0,0,0-1.81-1.4L32.65,6.08A3,3,0,0,0,29,8.2L20.77,38.09a3,3,0,0,0,.29,2.28,3,3,0,0,0,1.81,1.41L31.12,44A1,1,0,0,1,30.6,46L22.35,43.7a5,5,0,0,1-3-2.34,4.93,4.93,0,0,1-.47-3.79L27,7.67a5,5,0,0,1,6.14-3.51L56.31,10.5a5,5,0,0,1,3.51,6.13L52,45.26A1,1,0,0,1,51,46Z"/>
                    <path className="cls-3" d="M47.46,17.36a1.24,1.24,0,0,1-.27,0L38.51,15A1,1,0,0,1,39,13l8.68,2.38a1,1,0,0,1-.26,2Z"/>
                    <path className="cls-3" d="M48.77,23.94a1.24,1.24,0,0,1-.27,0L34,20A1,1,0,1,1,34.56,18L49,22a1,1,0,0,1-.26,2Z"/>
                    <path className="cls-3" d="M47.18,29.73a.78.78,0,0,1-.26,0l-14.47-4A1,1,0,1,1,33,23.81l14.47,4a1,1,0,0,1,.7,1.22A1,1,0,0,1,47.18,29.73Z"/>
                    <path className="cls-3" d="M45.6,35.52a.84.84,0,0,1-.27,0l-14.47-4a1,1,0,1,1,.53-1.93l14.47,4a1,1,0,0,1,.7,1.23A1,1,0,0,1,45.6,35.52Z"/>
                </g>
            </g>

        </svg>
        <Box sx={{mt: 2}} color={'gray'}>{label}</Box></>
}

const FileOverlay = ({label}: GridOverlayType) => {
    return <>
        <svg width="66px" height="66px" viewBox="0 0 1024 1024" className="icon" version="1.1" xmlns="http://www.w3.org/2000/svg" fill="#AEB8C2">
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
            <g id="SVGRepo_iconCarrier">
                <path d="M220.5 245.4c-32.8 32.8-55.1 73.2-65.2 117.3h16.5c18.8-75.3 75.1-135.9 148-160.7v-16.9c-37.1 11.6-71 32-99.3 60.3z" fill="#AEB8C2"></path>
                <path
                    d="M959.9 540.8c0 113.6-92.1 205.8-205.7 205.9H590.9v-44h163.3c43.2 0 83.8-16.9 114.3-47.4 30.6-30.6 47.4-71.2 47.4-114.5 0-43.2-16.8-83.9-47.4-114.4S797.2 379 754 379c-11.5 0-22.8 1.2-33.8 3.5-15 3.2-29.4 8.4-42.8 15.7-1-15.4-3.3-30.7-6.8-45.6v-0.1c-3.6-15.6-8.6-30.8-14.9-45.7-14.4-33.9-34.9-64.4-61.1-90.6-26.2-26.2-56.6-46.7-90.6-61.1-35.1-14.8-72.4-22.4-110.9-22.4s-75.8 7.5-110.9 22.4c-33.9 14.3-64.4 34.9-90.6 61.1-26.2 26.2-46.7 56.7-61.1 90.6-14.9 35.1-22.4 72.4-22.4 110.9s7.5 75.8 22.4 110.9c14.3 33.9 34.9 64.4 61.1 90.6 26.2 26.2 56.7 46.7 90.6 61.1 35.1 14.8 72.4 22.4 110.9 22.4h39.7v44h-41C210.7 746 64.1 599 64.1 417.7c0-181.7 147.3-329 329-329 154.6 0 284.3 106.6 319.5 250.3v0.1c13.4-2.7 27.2-4.2 41.4-4.2 113.7 0.1 205.9 92.2 205.9 205.9z"
                    fill="#AEB8C2AEB8C2"></path>
                <path d="M692.9 636.1h-22.6L519.8 485.6v449.6h-16V485.8L353.4 636.1h-22.6l181-181z" fill="#AEB8C2"></path>
            </g>
        </svg>
        <Box sx={{mt: 2}} color={'gray'}>{label}</Box></>
}

const DefaultOverlay = ({label}: GridOverlayType) => {
    return <>
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            width={96}
            viewBox="0 0 523 299"
            aria-hidden
            focusable="false"
        >
            <path
                className="no-results-primary"
                d="M262 20c-63.513 0-115 51.487-115 115s51.487 115 115 115 115-51.487 115-115S325.513 20 262 20ZM127 135C127 60.442 187.442 0 262 0c74.558 0 135 60.442 135 135 0 74.558-60.442 135-135 135-74.558 0-135-60.442-135-135Z"
            />
            <path
                className="no-results-primary"
                d="M348.929 224.929c3.905-3.905 10.237-3.905 14.142 0l56.569 56.568c3.905 3.906 3.905 10.237 0 14.143-3.906 3.905-10.237 3.905-14.143 0l-56.568-56.569c-3.905-3.905-3.905-10.237 0-14.142ZM212.929 85.929c3.905-3.905 10.237-3.905 14.142 0l84.853 84.853c3.905 3.905 3.905 10.237 0 14.142-3.905 3.905-10.237 3.905-14.142 0l-84.853-84.853c-3.905-3.905-3.905-10.237 0-14.142Z"
            />
            <path
                className="no-results-primary"
                d="M212.929 185.071c-3.905-3.905-3.905-10.237 0-14.142l84.853-84.853c3.905-3.905 10.237-3.905 14.142 0 3.905 3.905 3.905 10.237 0 14.142l-84.853 84.853c-3.905 3.905-10.237 3.905-14.142 0Z"
            />
            <path
                className="no-results-secondary"
                d="M0 43c0-5.523 4.477-10 10-10h100c5.523 0 10 4.477 10 10s-4.477 10-10 10H10C4.477 53 0 48.523 0 43ZM0 89c0-5.523 4.477-10 10-10h80c5.523 0 10 4.477 10 10s-4.477 10-10 10H10C4.477 99 0 94.523 0 89ZM0 135c0-5.523 4.477-10 10-10h74c5.523 0 10 4.477 10 10s-4.477 10-10 10H10c-5.523 0-10-4.477-10-10ZM0 181c0-5.523 4.477-10 10-10h80c5.523 0 10 4.477 10 10s-4.477 10-10 10H10c-5.523 0-10-4.477-10-10ZM0 227c0-5.523 4.477-10 10-10h100c5.523 0 10 4.477 10 10s-4.477 10-10 10H10c-5.523 0-10-4.477-10-10ZM523 227c0 5.523-4.477 10-10 10H413c-5.523 0-10-4.477-10-10s4.477-10 10-10h100c5.523 0 10 4.477 10 10ZM523 181c0 5.523-4.477 10-10 10h-80c-5.523 0-10-4.477-10-10s4.477-10 10-10h80c5.523 0 10 4.477 10 10ZM523 135c0 5.523-4.477 10-10 10h-74c-5.523 0-10-4.477-10-10s4.477-10 10-10h74c5.523 0 10 4.477 10 10ZM523 89c0 5.523-4.477 10-10 10h-80c-5.523 0-10-4.477-10-10s4.477-10 10-10h80c5.523 0 10 4.477 10 10ZM523 43c0 5.523-4.477 10-10 10H413c-5.523 0-10-4.477-10-10s4.477-10 10-10h100c5.523 0 10 4.477 10 10Z"
            />
        </svg>
        <Box sx={{mt: 2}}>{label || '暂无数据'}</Box></>
}

interface NoResultsOverlayProps {
    kind: "file" | 'doc' | "default"
    label?: string
    onClick?: () => void
}

// 空数据页面
const NoResultsOverlay: React.FC<NoResultsOverlayProps> = ({kind, label,onClick}) => {
    const renderOverlay = useMemo(() => {
        if (kind == 'file') {
            return <FileOverlay label={label!}/>
        } else if (kind == 'doc') {
            return <DocOverlay label={label!}/>
        }
        return <DefaultOverlay label={label!}/>
    }, []);

    return (
        <StyledGridOverlay onClick={onClick}>
            {renderOverlay}
        </StyledGridOverlay>
    );
};

export default NoResultsOverlay;
